import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import { Translate } from 'react-redux-i18n';
export const Footer = () => (
  <Col xs={12} className="footer-block">
    <span className="footer-text">
      <Translate value="shop.agreement" />
      &nbsp;
      <a href="/docs/policy.doc" download>
        <Translate value="shop.policy" />
      </a>
      <Translate value="shop.and" />
      &nbsp;
      <a
        href="https://progkids.com/agreement"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Translate value="shop.oferta" />
      </a>
      .
    </span>

    <img
      src={require('../../assets/images/landings/logo-grayscale.png')}
      alt="progkids grayscale"
      className="footer-logo"
    />
  </Col>
);
